<article *ngIf="panel?.active"
  class="w-full flex align-items-center justify-content-center p-2 ci-bg--grey-lighten border-round-xl">
  <main class="w-full">
    <section class="w-full flex flex-column gap-2">
      <section class="w-full flex justify-content-start">
        <section class="w-full ci-txt--white text-xl ci-bg--black border-round-xl overflow-hidden py-1">
          <app-weather-time *ngIf="panel.origin" [coords]="getLocationCoords(panel.origin)">
          </app-weather-time>
        </section>
      </section>
    
      <section class="w-full ci-panel__marquee-container text-2xl border-round-xl overflow-hidden">
        <app-message [slug]="slug" [customClass]="'ci-panel__resume-item'"></app-message>
      </section>

      <swiper-container autoplay-delay="5000" class="w-full h-full">
        <swiper-slide *ngFor="let item of panel?.lanes, index as i" class="flex flex-column gap-2">
          <div class="bg-white-alpha-50 border-round-xl px-3 py-2 text-xl">
            <div *ngFor="let destination of item.routes" class="w-full ci-txt--black flex justify-content-between align-items-center">
              <section class="flex flex-grow-1">
                <div class="w-full overflow-hidden ci-ellipsis-1">
                  {{destination.title}}
                </div>
              </section>

              <div *ngIf="!showDistance && destination.details[0]?.duration"
                class="w-4 fadein animation-duration-1000 flex justify-content-end align-items-center overflow-hidden">
                <i class="bi bi-car-front mr-2"></i>

                <small class="flex align-items-center">
                  {{getMinutes(destination.details[0]?.duration_in_traffic)}}
                  <div class="flex align-items-center justify-content-center font-light ml-1">
                    min
                  </div>
                </small>
              </div>

              <div *ngIf="showDistance && destination.details[0]?.distance"
                class="w-4 fadein animation-duration-1000 flex justify-content-end align-items-center">
                <i class="bi bi-car-front mr-2"></i>

                <small class="font-normal flex justify-content-end align-items-center">
                  {{getKilometers(destination.details[0]?.distance)}}
                  <p class="ml-1 font-light">Km</p>
                </small>
              </div>
            </div>
          </div>

          <div
            class="w-full flex align-items-center justify-content-between ci-bg--green-traffic border-round-xl px-3 py-1">
            <div class="ci-txt--white text-2xl">
              {{item?.name}}
            </div>

            <div class="w-2rem h-2rem" [ngClass]="{'ci-panel__body-main-direction-arrow--left': item.orientation === 'Izquierda',
                   'ci-panel__body-main-direction-arrow--right': item.orientation === 'Derecha'}">
              <img src="assets/images/mv-arrow.png" alt="Direction arrow" class="w-full h-full">
            </div>
          </div>
        </swiper-slide>
      </swiper-container>
    </section>
  </main>
</article>